import { minimumWidth, pxToRem, styled } from '@feast-it/ui/light';

export const Items = styled.div`
  border-top: ${pxToRem(1)} solid rgba(18, 18, 18, 0.1);
  width: 100%;
`;

export const BackgroundIconRight = styled.div`
  ${({ theme }) => `
    opacity: 0.05;
    position: absolute;
    right: ${pxToRem(-250)};
    top: ${pxToRem(250)};
    z-index: 0;

    ${minimumWidth(theme.breakpoints.medium)} {
      right: ${pxToRem(-450)};
      top: ${pxToRem(-10)};
    }

    ${minimumWidth(theme.breakpoints.large)} {
      right: ${pxToRem(-350)};
      top: ${pxToRem(-10)};
    }
  `}
`;

export const BackgroundIconLeft = styled.div`
  ${({ theme }) => `
    opacity: 0.05;
    left: ${pxToRem(-270)};
    position: absolute;
    top: ${pxToRem(-200)};
    z-index: 0;

    ${minimumWidth(theme.breakpoints.medium)} {
      left: ${pxToRem(-400)};
      top: ${pxToRem(-400)};
    }

    ${minimumWidth(theme.breakpoints.extraLarge)} {
      left: ${pxToRem(-400)};
      top: ${pxToRem(-300)};
    }
  `}
`;

export const colLink = styled.a`
  ${({ theme }) => `
    color: ${theme.colors.mediumBlue};
    display: block;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
    outline: none;
    position: relative;
    text-decoration: underline;
    text-underline-offset: ${pxToRem(4)};
  `}
`;
